import { utils } from 'pixi.js';

export enum HudActions {
    ADD_CURRENCY = 'add currency',
    SHOW_POPUP = 'show popup',
    ADD_POPUP = 'add popup',
    CLOSE_POPUP = 'remove popup',
    POPUP_CLOSED = 'popup closed',
    GAME_BOOSTER_SELECT = 'game booster select',
    TOGGLE_SOUND = 'toggle sound',
    TOGGLE_MUSIC = 'toggle music',
    QUIT_GAME = 'quit game',
    SOCIALHUB_REQUEST_GIFT = 'socialhub request gift',
    SOCIALHUB_SEND_GIFT = 'socialhub send gift',
    SOCIALHUB_START_LOAD_SOCIAL = 'socialhub start load social',
    SOCIALHUB_STOP_LOAD_SOCIAL = 'socialhub stop load social',
    WATCH_REWARDED_AD = 'watch rewarded ad',
    MISSION_COLLECT_COINS = 'mission collect coins',
    MISSION_SELECT_REFRESH = 'mission select refresh',
    MISSION_MILESTONE_COLLECTED = 'mission milestone collected',
    RECEIVE_REWARDS = 'receive rewards',
    PRIZE_WHEEL_ACTION = 'prize wheel action',
    OPEN_REWARD_BOX = 'open reward box',
    WATCH_PRESENT_AD = 'watch present ad',
    SET_COLLECTION = 'set collection',
    SET_PAUSE_VISIBLE = 'set pause visible',
    SHARE_MOMENT = 'share moment',
    SHARE_MOMENT_COMPLETE = 'share moment complete',
    SET_PAUSED = 'set paused',
    SHOW_BOOSTER_PARACHUTE = 'show booster parachute',
    HIDE_BOOSTER_PARACHUTE = 'hide booster parachute',
    SHOW_ACTIVATION_PARACHUTE = 'show activation parachute',
    ASK_FRIEND = 'ask friend for help',
    INVITE_PLAYER = 'invite player',
    SHOW_CURR_ADDS = 'show curr ads',
    LEVEL_INIT = 'level init',
    LEVEL_RETRY = 'level retry',
    BUY_PRODUCT = 'buy product',
    MODAL = 'modal',
    SWITCH_GAME = 'switch game',
}

export class HudEmitter extends utils.EventEmitter {
    private static instanceCache: HudEmitter;

    static get instance(): HudEmitter {
        if (!this.instanceCache) {
            this.instanceCache = new HudEmitter();
        }
        return this.instanceCache;
    }

    constructor() {
        super();
    }
}
